export { default } from './loadingSpinner';


// WEBPACK FOOTER //
// ./src/components/loadingSpinner/index.js